import { createSvgIcon } from '@mui/material';

export const TransactionIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
    <path
      fill="currentColor"
      d="M13.732 10.106a.5.5 0 0 0 .852.355L18.43 6.66a.5.5 0 0 0 0-.711l-3.845-3.803a.5.5 0 0 0-.851.356v2.802H8.788v2h4.944v2.803ZM6.056 16.802a.5.5 0 0 1-.851.356L1.36 13.355a.5.5 0 0 1 0-.71l3.845-3.803a.5.5 0 0 1 .851.356V12H11v2H6.056v2.802Z"
    />
  </svg>,
  'TransactionIcon',
);
